@use '../../style/functions';
@use '../../style/internal/shared_input-select-picker';
@use '../../style/mixins';

@use '@material/select/styles';

// Note! The `--dropdown-z-index` property is used from `select.tsx`.
/**
 * @prop --dropdown-z-index: z-index of the dropdown menu.
 */

$border-radius: 0.375rem;

:host(limel-select) {
    --limel-notched-outline-border-radius: #{$border-radius};
    display: block;
    position: relative;
}

:host([hidden]) {
    display: none;
}

limel-notched-outline:not([invalid]:not([invalid='false'])) {
    .limel-notched-outline--outlines {
        --limel-notched-outline-border-color: transparent;
    }
}

.mdc-select__anchor,
.mdc-select__selected-text {
    // As long as this component is depended on MDC,
    // we need to force it to be font-agnostic.
    // When MDC-dependency is removed, this block can also be removed.
    // However, on removal of MDC-dependency, we should also make sure to check
    // other font-related styles that might be set by MDC,
    // such as `letter-spacing` or `font-size`.
    font-family: inherit;
    font-size: var(--limel-theme-default-font-size);
}

.mdc-select__dropdown-icon-graphic {
    transition: transform 0.2s ease;
}

.limel-select__selected-option {
    display: flex;
    align-items: center;

    box-sizing: border-box;
    outline: none;

    align-self: center;
    min-width: 0; // makes it truncate and prevents the select to grow wider than its container
    padding: 0 0.25rem 0 1rem;
}

.limel-select__selected-option__icon {
    margin-right: functions.pxToRem(8);
    margin-left: functions.pxToRem(-8);
    flex-shrink: 0;
}

.limel-select__selected-option__text {
    .mdc-select:not(.mdc-select--disabled) & {
        color: shared_input-select-picker.$input-text-color;
    }

    .mdc-select.mdc-select--disabled & {
        color: shared_input-select-picker.$input-text-color-disabled;
    }

    @include mixins.truncate-text;
}

.limel-select {
    flex-wrap: wrap;
    width: 100%;

    .mdc-select__anchor {
        height: functions.pxToRem(36);
        padding-left: functions.pxToRem(0);
    }
    .limel-select-trigger {
        border: none;
        height: shared_input-select-picker.$height-of-mdc-text-field;
        display: inline-flex;
        align-items: center;

        border-radius: $border-radius;
    }

    .limel-select-trigger,
    .limel-select__selected-option {
        width: 100%;
    }

    .mdc-select__dropdown-icon {
        margin-right: 0.25rem;
        margin-left: 0.25rem;
    }

    &.mdc-select--disabled:not(.limel-select--readonly) {
        .limel-select-trigger {
            @include shared_input-select-picker.looks-disabled;
            box-shadow: var(--button-shadow-normal);
        }
        .mdc-select__dropdown-icon {
            svg {
                fill: rgb(var(--contrast-800));
            }
        }
    }

    &:not(.mdc-select--disabled) {
        .mdc-select__dropdown-icon {
            svg {
                fill: rgb(var(--contrast-1000));
            }
        }

        .limel-select-trigger {
            @include mixins.is-elevated-clickable;
            @include mixins.visualize-keyboard-focus;

            &.limel-select--focused {
                background-color: shared_input-select-picker.$background-color-focused;

                .mdc-select__dropdown-icon {
                    svg {
                        fill: var(
                            --lime-primary-color,
                            var(--limel-theme-primary-color)
                        );
                    }
                }

                .mdc-select__dropdown-icon-graphic {
                    transform: rotate(-180deg);
                }
            }

            &[aria-expanded]:not([aria-expanded='false']),
            &[aria-expanded='true'] {
                box-shadow: var(--button-shadow-inset-pressed);
            }
        }
    }

    &.limel-select--invalid {
        .limel-select__selected-option__text,
        .invalid-icon {
            color: var(--limel-theme-error-text-color);
        }
    }
}

.invalid-icon {
    flex-shrink: 0;
}

select.limel-select__native-control {
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;
    opacity: 0;
    border: 0;
}

@import './partial-styles/_readonly';
@import './partial-styles/_helper-text';
